import { render, staticRenderFns } from "./MenuOptionsDashboard.vue?vue&type=template&id=0fd7e7c6"
import script from "./MenuOptionsDashboard.vue?vue&type=script&lang=js"
export * from "./MenuOptionsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports